import { render } from "./DepositView.vue?vue&type=template&id=ec8507c4"
import script from "./deposit-view-component.ts?vue&type=script&lang=js&external"
export * from "./deposit-view-component.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__